import { graphql as gql } from 'react-relay';
const graphql = gql;

export const instantSearchFragment = graphql`
  fragment instantSearch_viewer on Viewer {
    trackInstantSearch(query: $query) {
      artists {
        id
        name
        slug
      }
      tracks {
        id
        slug
        title
        artist{
          name
        }
      }
      taxonomies {
        id
        internal_id
        name
        terms {
          id
          name
        }
      }
    }
  }
`;

export const instantSearchRefetchQuery = graphql`
  query instantSearchRefetchQuery($query: String) {
    viewer {
      ...instantSearch_viewer
    }
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/instantSearch.ts